document.addEventListener('DOMContentLoaded', function() {
  initializeTomSelects()
})

const tomSelectsSelector = 'select:not(.tomselected):not([class*="flatpickr-"])'

const initializeTomSelects = () => {
  // find select with no tomselect applied yet
  const selects = document.querySelectorAll(tomSelectsSelector)

  selects.forEach(select => {
    select.setAttribute('data-controller', 'tomselect')
  })
}

Ready(() => {
  initializeTomSelects()

  document.addEventListener('turbo:frame-render', () => {
    initializeTomSelects()
  })

  // For full-page Turbo navigation
  document.addEventListener('turbo:render', () => {
    initializeTomSelects()
  })

  // For Turbo Streams before rendering (if you want to set data-controller)
  document.addEventListener('turbo:before-stream-render', (event) => {
    event.target.templateElement.content.querySelectorAll(tomSelectsSelector).forEach(select => {
      select.setAttribute('data-controller', 'tomselect')
    })
  })
})
